<template>
  <div class="outage-banner-wrapper">
    <modal-header :title="outageTitle" :on-modal-close="close" />
    <div v-html="outageMessage" class="content pb-5 px-5">
    </div>
    <modal-footer class="text-center" :buttonConfigs=[buttonConfig]></modal-footer>
  </div>
</template>

<script>

import ModalHeader from "./modals/ModalHeader";
import ModalFooter from "./modals/ModalFooter";

export default {
  name: "outage-banner-modal",
  components: {
    ModalFooter,
    ModalHeader
  },
  data() {
    return {
      buttonConfig: {text: "Ok", clickHandler: this.close, class: "homebase-btn-primary"}
    };
  },
  props: {
    outageTitle: String,
    outageMessage: String
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
};
</script>

<style scoped>
.outage-banner-wrapper {
  position: relative;
}

.content {
  font-size: 14px;
  font-family: artifaktElementRegular !important;
  color: rgb(0, 0, 0);
  margin: 0px;
  min-height: 20px;
  padding: 16px 46px 20px 24px;
  line-height: normal;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/OutageBannerModal.vue